// This screen is a loading screen, to show while all the various
// necessary objects are retrieved from the backend.

import React from "react";

import Snackbar from "../components/Snackbar";

import LoadingScreen from "./LoadingScreen";
import StartScreenBackground from "./StartScreenBackground";

type Props = {
  hideBackground?: boolean;
};
const StartupScreen: React.FC<Props> = ({ hideBackground }) => {
  return (
    <StartScreenBackground hideBackground={hideBackground}>
      <Snackbar />
      <LoadingScreen />
    </StartScreenBackground>
  );
};

export default StartupScreen;
